/**
 * 인앱 브라우저 감지 및 외부 브라우저 열기 유틸리티
 *
 * 카카오톡, 네이버, 인스타그램, 페이스북, 라인, 텔레그램, 다음 등
 * 인앱 브라우저에서 Google OAuth가 차단되는 문제 해결
 */

/**
 * 인앱 브라우저 감지
 * @returns {{ isInApp: boolean, name: string|null }}
 */
export function detectInAppBrowser() {
  const ua = navigator.userAgent || '';

  // 카카오톡
  if (/KAKAOTALK/i.test(ua)) {
    return { isInApp: true, name: '카카오톡' };
  }

  // 네이버
  if (/NAVER\(|NaverSearch/i.test(ua)) {
    return { isInApp: true, name: '네이버' };
  }

  // 인스타그램
  if (/Instagram/i.test(ua)) {
    return { isInApp: true, name: '인스타그램' };
  }

  // 페이스북
  if (/FBAN|FBAV/i.test(ua)) {
    return { isInApp: true, name: '페이스북' };
  }

  // 라인
  if (/\bLine\//i.test(ua)) {
    return { isInApp: true, name: 'LINE' };
  }

  // 텔레그램
  if (/Telegram/i.test(ua) || window.Telegram?.WebApp || window.TelegramWebviewProxy) {
    return { isInApp: true, name: '텔레그램' };
  }

  // 다음
  if (/DaumApps/i.test(ua)) {
    return { isInApp: true, name: '다음' };
  }

  // 트위터/X
  if (/Twitter/i.test(ua)) {
    return { isInApp: true, name: 'X(Twitter)' };
  }

  return { isInApp: false, name: null };
}

/**
 * 외부 브라우저에서 현재 페이지 열기
 * @param {string} [url] - 열 URL (기본값: 현재 페이지)
 */
export function openInExternalBrowser(url) {
  const targetUrl = url || window.location.href;
  const ua = navigator.userAgent || '';

  // Android: intent scheme으로 기본 브라우저 실행
  if (/Android/i.test(ua)) {
    const intentUrl = `intent://${targetUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;action=android.intent.action.VIEW;end`;
    window.location.href = intentUrl;
    return;
  }

  // iOS: Safari로 열기 시도
  // 카카오톡 iOS는 'kakaotalk://web/openExternal?url=' 지원
  if (/KAKAOTALK/i.test(ua) && /iPhone|iPad|iPod/i.test(ua)) {
    window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(targetUrl)}`;
    return;
  }

  // 기타 iOS 인앱: Safari 열기 시도 (window.open fallback)
  if (/iPhone|iPad|iPod/i.test(ua)) {
    // Safari에서 열기 위해 _blank 시도
    window.open(targetUrl, '_system') || window.open(targetUrl, '_blank');
    return;
  }

  // 데스크톱 등 기타: 새 탭
  window.open(targetUrl, '_blank');
}
